import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1C7.75708 2.70696 6.97956 4.35243 5.66667 5.66553C4.35342 6.97876 2.70725 7.75711 1 8C2.70724 8.24289 4.35343 9.02126 5.66667 10.3345C6.97957 11.6475 7.75706 13.2931 8 15C8.24293 13.293 9.02145 11.6476 10.3345 10.3345C11.6475 9.02145 13.293 8.24299 15 8C13.2931 7.75702 11.6475 6.97951 10.3345 5.66667C9.02133 4.35349 8.24293 2.70715 8 1Z" fill="currentColor" />
    </svg>

  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1C7.75708 2.70696 6.97956 4.35243 5.66667 5.66553C4.35342 6.97876 2.70725 7.75711 1 8C2.70724 8.24289 4.35343 9.02126 5.66667 10.3345C6.97957 11.6475 7.75706 13.2931 8 15C8.24293 13.293 9.02145 11.6476 10.3345 10.3345C11.6475 9.02145 13.293 8.24299 15 8C13.2931 7.75702 11.6475 6.97951 10.3345 5.66667C9.02133 4.35349 8.24293 2.70715 8 1Z" fill="currentColor" />
    </svg>

  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2C9.72238 3.95081 8.83378 5.83135 7.33333 7.33203C5.83248 8.83286 3.95115 9.72241 2 10C3.95113 10.2776 5.83249 11.1672 7.33333 12.668C8.83379 14.1686 9.72236 16.0492 10 18C10.2776 16.0491 11.1674 14.1687 12.668 12.668C14.1686 11.1674 16.0491 10.2777 18 10C16.0493 9.72231 14.1686 8.83372 12.668 7.33333C11.1672 5.83257 10.2776 3.95102 10 2Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.54613 0.437794C7.79653 0.187402 8.20287 0.187402 8.45327 0.437794L15.5624 7.54685C15.8125 7.79722 15.8126 8.20288 15.5624 8.45319L12.0247 11.9909C12.0136 12.002 12.0021 12.0127 11.991 12.0238L8.45327 15.5622C8.20288 15.8126 7.79651 15.8126 7.54613 15.5622L0.437771 8.45319C0.187393 8.20282 0.187427 7.79725 0.437771 7.54685L7.54613 0.437794ZM8.00009 3.19125C7.83321 4.36388 7.29907 5.49426 6.39715 6.39632C5.49498 7.29846 4.3641 7.83316 3.19126 8.00002C4.36409 8.16688 5.49499 8.7016 6.39715 9.60373C7.29908 10.5058 7.8332 11.6362 8.00009 12.8088C8.16698 11.6361 8.70181 10.5058 9.60382 9.60373C10.5059 8.70172 11.6363 8.16695 12.8089 8.00002C11.6364 7.8331 10.5058 7.29898 9.60382 6.3971C8.70172 5.49499 8.16698 4.36401 8.00009 3.19125Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.54613 0.437794C7.79653 0.187402 8.20287 0.187402 8.45327 0.437794L15.5624 7.54685C15.8125 7.79722 15.8126 8.20288 15.5624 8.45319L12.0247 11.9909C12.0136 12.002 12.0021 12.0127 11.991 12.0238L8.45327 15.5622C8.20288 15.8126 7.79651 15.8126 7.54613 15.5622L0.437771 8.45319C0.187393 8.20282 0.187427 7.79725 0.437771 7.54685L7.54613 0.437794ZM8.00009 3.19125C7.83321 4.36388 7.29907 5.49426 6.39715 6.39632C5.49498 7.29846 4.3641 7.83316 3.19126 8.00002C4.36409 8.16688 5.49499 8.7016 6.39715 9.60373C7.29908 10.5058 7.8332 11.6362 8.00009 12.8088C8.16698 11.6361 8.70181 10.5058 9.60382 9.60373C10.5059 8.70172 11.6363 8.16695 12.8089 8.00002C11.6364 7.8331 10.5058 7.29898 9.60382 6.3971C8.70172 5.49499 8.16698 4.36401 8.00009 3.19125Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.42901 0.486257C9.74402 0.171248 10.2552 0.171248 10.5702 0.486257L19.514 9.42991C19.8286 9.74489 19.8287 10.2552 19.514 10.5701L15.0633 15.0208C15.0494 15.0348 15.035 15.0483 15.021 15.0622L10.5702 19.5138C10.2552 19.8287 9.744 19.8287 9.42901 19.5138L0.486228 10.5701C0.171236 10.2552 0.171279 9.74493 0.486228 9.42991L9.42901 0.486257ZM10.0001 3.95029C9.79017 5.42552 9.11819 6.84762 7.98351 7.98246C6.84853 9.11742 5.42581 9.79011 3.9503 10C5.4258 10.2099 6.84853 10.8827 7.98351 12.0176C9.1182 13.1524 9.79015 14.5745 10.0001 16.0498C10.2101 14.5745 10.8829 13.1525 12.0177 12.0176C13.1525 10.8828 14.5746 10.21 16.0499 10C14.5748 9.79003 13.1525 9.11807 12.0177 7.98345C10.8828 6.84854 10.2101 5.42568 10.0001 3.95029Z" fill="currentColor" />
    </svg>

  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconAi: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"ai"} {...props} />
);
